import React from "react"

interface IProps {
  children?: React.ReactNode
}

const SvgLoader = ({ children }: IProps): React.JSX.Element => {
  return (
    <div className="svg-loader d-flex justify-content-center align-items-center flex-column text-center" style={{ height: "85vh" }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" style={{ width: "75px", height: "75px" }}>
        <radialGradient id="a5" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
          <stop offset="0" stopColor="#FF156D"></stop>
          <stop offset=".3" stopColor="#FF156D" stopOpacity=".9"></stop>
          <stop offset=".6" stopColor="#FF156D" stopOpacity=".6"></stop>
          <stop offset=".8" stopColor="#FF156D" stopOpacity=".3"></stop>
          <stop offset="1" stopColor="#FF156D" stopOpacity="0"></stop>
        </radialGradient>
        <circle transform="rotate(0 100 100)" fill="none" stroke="url(#a5)" strokeWidth="15" strokeLinecap="round" strokeDasharray="200 1000" strokeDashoffset="0" cx="100" cy="100" r="70">
          <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360 100 100;0 100 100" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
        </circle>
        <circle fill="none" opacity=".2" stroke="#FF156D" strokeWidth="15" strokeLinecap="round" cx="100" cy="100" r="70"></circle>
      </svg>
      {children}
    </div>
  )
}

export default SvgLoader
